import { API_BASE_URL } from '../config/api';

export interface ApiResponse<T> {
  ok: boolean;
  data?: T;
  problem?: string;
  status?: number;
}

export interface ApiError {
  type?: string;
  message?: string;
}

let logoutCallback: (() => void) | null = null;

export function setLogoutCallback(callback: () => void): void {
  logoutCallback = callback;
}

async function request<T>(
  endpoint: string,
  options: RequestInit = {},
): Promise<ApiResponse<T>> {
  const url = `${API_BASE_URL}${endpoint}`;

  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    const data = await response.json();

    if (data.error && data.error.type === 'login' && logoutCallback) {
      logoutCallback();
    }

    return {
      ok: response.ok,
      data,
      status: response.status,
    };
  } catch (error) {
    return {
      ok: false,
      problem: error instanceof Error ? error.message : 'Network error',
    };
  }
}

export async function get<T>(endpoint: string): Promise<ApiResponse<T>> {
  return request<T>(endpoint, { method: 'GET' });
}

export async function post<T>(
  endpoint: string,
  body?: Record<string, unknown>,
): Promise<ApiResponse<T>> {
  return request<T>(endpoint, {
    method: 'POST',
    body: body ? JSON.stringify(body) : undefined,
  });
}

export default {
  get,
  post,
  setLogoutCallback,
};
